export default __webpack_public_path__ + "static/media/bw_dark.c668aba3.png";